import React from "react";
import { bool, string, element, oneOfType, func } from "prop-types";

const Overlay = ({
  show,
  children,
  onOutsideClick = () => {},
  overNav = false,
}) =>
  show && (
    <div
      onClick={onOutsideClick}
      className="p-hf"
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        zIndex: `${overNav ? "2000" : "10"}`,
        backgroundColor: "rgba(0,0,0,0.5)",
      }}
    >
      <div
        className="d-flex justify-content-center w-100"
        onClick={(e) => e.stopPropagation()}
      >
        {children}
      </div>
    </div>
  );

Overlay.propTypes = {
  show: bool,
  children: oneOfType([element, string]),
  onOutsideClick: func,
  overNav: bool,
};

export default Overlay;
